import fetch from "auth/FetchInterceptor";
import { env } from "configs/EnvironmentConfig";

const AuthService = {};

const API_BASE_URL = env.API_ENDPOINT_URL;
const cntrlName = "Parent/"; 

AuthService.login= function (data) {
  const { emailaddress, password } = data;

  return fetch({
    url: `${API_BASE_URL + cntrlName}login`,
    method: "post",
    data: {
      Email: emailaddress,
      password: password,
    },
  });
};

AuthService.driverlogin= function (data) {
  const { emailaddress, password } = data;

  return fetch({
    url: `${API_BASE_URL + cntrlName}DriverLogin`,
    method: "post",
    data: {
      Email: emailaddress,
      password: password,
    },
  });
};

export default AuthService;
